import React from 'react';
import PropTypes from 'prop-types';
import ConnectedTextField from '../../_atomic/ConnectedTextField/ConnectedTextField';
import { fullNameValidation } from '../../../utils/helpers';

const FullNameField = ({
  label,
  placeholder,
  isRequired,
  name,
  value,
  isFocused,
  disabled,
  status,
  errorText,
  contextProvider,
}) => (<ConnectedTextField
  label={label}
  type="text"
  placeholder={placeholder}
  isRequired={isRequired}
  specifiedValidator={fullNameValidation}
  value={value}
  isFocused={isFocused}
  status={status}
  disabled={disabled}
  errorText={errorText}
  name={name}
  contextProvider={contextProvider}
  errorSign
/>);

FullNameField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  status: PropTypes.string.isRequired,
  isFocused: PropTypes.bool,
  contextProvider: PropTypes.string,
  disabled: PropTypes.bool,
};
FullNameField.defaultProps = {
  label: 'Full Name',
  placeholder: 'Full Name',
  isRequired: false,
  name: '',
  errorText: '',
  disabled: false,
  isFocused: false,
  contextProvider: '',
};
export default FullNameField;



// WEBPACK FOOTER //
// ./src/components/_molecules/FullNameField/FullNameField.js